import { Navigate } from 'react-router-dom';
import { useAuthSession } from 'hooks/useAuthSession';
import { getRootRedirect } from 'utils/authNavigation';

/**
 * Sends `/` to the app entry point instead of 404.
 * Post-login return paths are only consumed after sign-in (see getGuestRouteRedirect).
 */
export default function RootRedirect() {
  const session = useAuthSession();
  return <Navigate to={getRootRedirect(session)} replace />;
}
